import { useMemo } from 'react';

import { useCardFiltering } from './useCardFiltering';
import { useIntentNavigation } from './useIntentNavigation';
import { useIntentTextData } from './useIntentTextData';
import { useUserIntentFetch } from './useUserIntentFetch';

/**
 * Main hook that orchestrates navigation and text data
 */
export const useUserIntents = () => {
  const { fetchedIntents, hasMoreThanOneCause, userCauseSelections, isLoading } =
    useUserIntentFetch();

  // Generate navigation intents and text data
  const navigationIntents = useIntentNavigation(fetchedIntents);
  const textData = useIntentTextData(fetchedIntents);

  // Apply card-specific filtering to navigation intents
  const { individualCardIntents, combinedCardIntents } = useCardFiltering(
    navigationIntents,
    hasMoreThanOneCause
  );

  return useMemo(
    () => ({
      // Navigation data (filtered versions of navigationIntents)
      userIntents: individualCardIntents,
      allCauseIntents: combinedCardIntents,

      // Text data
      textData,

      // Other data
      userCauseSelections,
      isLoading,
    }),
    [individualCardIntents, combinedCardIntents, textData, userCauseSelections, isLoading]
  );
};
